export default function arrayToggle(arr: any[], item: any) {
	const idx = arr.indexOf(item);
	if (idx !== -1) {
		arr.splice(idx, 1);
		return false;
	} else {
		arr.push(item);
		return true;
	}
}